import { Navigate } from 'react-router-dom'
import { useAuthState } from '../AuthProvider'
import { useRole } from '../../providers/RoleProvider'
import LoadingOverlay from '../../components/LoadingOverlay'

export default function UnguardedRoute({ children }: any) {
  const { isAuthenticated } = useAuthState()
  const { role, loading: roleLoading } = useRole()

  if (isAuthenticated && roleLoading) {
    return <LoadingOverlay />
  }

  if (isAuthenticated) {
    return <Navigate to={role === 'secretary' ? '/secretary' : '/dashboard'} />
  }

  return children
}
